var React = require('react');

function GreenCheckIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ICON-Info","transform":"translate(4955.135 48) rotate(180)"},React.createElement("path",{"id":"Subtraction_7","data-name":"Subtraction 7","d":"M24.632,48a25.037,25.037,0,0,1-9.588-1.886,24.6,24.6,0,0,1-7.83-5.143,23.9,23.9,0,0,1-5.279-7.628,23.51,23.51,0,0,1,0-18.684A23.894,23.894,0,0,1,7.214,7.029a24.6,24.6,0,0,1,7.83-5.143,25.315,25.315,0,0,1,19.176,0,24.594,24.594,0,0,1,7.829,5.143,23.894,23.894,0,0,1,5.279,7.628,23.51,23.51,0,0,1,0,18.684,23.9,23.9,0,0,1-5.279,7.628,24.6,24.6,0,0,1-7.829,5.143A25.034,25.034,0,0,1,24.632,48Zm4.293-34.671-18.663,18.3,3.109,3.048L28.925,19.43l6.222,6.1,3.115-3.049-6.225-6.1Z","transform":"translate(4905.872 0.001)","fill":"#43936f"})));
}

GreenCheckIcon.defaultProps = {"width":"49.263","height":"47.999","viewBox":"0 0 49.263 47.999"};

module.exports = GreenCheckIcon;

GreenCheckIcon.default = GreenCheckIcon;
